module.exports = __webpack_public_path__ + "img/takeVideo.f0b8c79e.png";